import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { Card, CardContent } from '@/components/ui/card'

// import type { ShopFilters } from './types'

interface ShopsFilterProps {
  // filters: ShopFilters
  // onFiltersChange: (filters: ShopFilters) => void
  onAddClick: () => void
}

// const STATUS_TABS = [
//   { label: 'ทั้งหมด', value: '' },
//   { label: 'เปิดใช้งาน', value: 'ACTIVE' },
//   { label: 'รอการอนุมัติ', value: 'PENDING' },
//   { label: 'ปิดใช้งาน', value: 'INACTIVE' },
// ] as const

// const ROLE_TABS = [
//   { label: 'ทั้งหมด', value: '' },
//   { label: 'ผู้ดูแลระบบ', value: 'ADMIN' },
//   { label: 'ร้านค้า', value: 'SHOP' },
// ] as const

export default function ShopsFilter({
  // filters,
  // onFiltersChange,
  onAddClick,
}: ShopsFilterProps) {
  // const [searchInput, setSearchInput] = useState(filters.search)

  // const handleSearchSubmit = (e: React.FormEvent) => {
  //   e.preventDefault()
  //   onFiltersChange({
  //     ...filters,
  //     search: searchInput,
  //     page: 1, // Reset to first page when searching
  //   })
  // }

  // const handleStatusChange = (status: string) => {
  //   onFiltersChange({
  //     ...filters,
  //     status,
  //     page: 1, // Reset to first page when filtering
  //   })
  // }

  // const handleRoleChange = (role: string) => {
  //   onFiltersChange({
  //     ...filters,
  //     role,
  //     page: 1, // Reset to first page when filtering
  //   })
  // }

  return (
    <Card>
      <CardContent>
        <div className="flex flex-col gap-6">
          {/* Header with Add Button */}
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-black">จัดการร้านค้า</h2>
            <Button onClick={onAddClick}>เพิ่มร้านค้า</Button>
          </div>

          <Separator className="border-gray-200" />

          {/* Search Bar */}
          {/* <form onSubmit={handleSearchSubmit} className="flex gap-2">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
              <Input
                placeholder="ค้นหาชื่อร้าน, อีเมล หรือเจ้าของร้าน..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="pl-10 rounded-lg border"
              />
            </div>
            <Button type="submit" variant="outline">
              ค้นหา
            </Button>
          </form> */}

          {/* Status Filter Tabs */}
          {/* <div className="space-y-4">
            <div className="space-y-2">
              <h3 className="text-base font-medium text-black">สถานะ</h3>
              <div className="flex gap-2 flex-wrap">
                {STATUS_TABS.map((tab) => (
                  <Button
                    key={tab.value}
                    variant={
                      filters.status === tab.value ? 'default' : 'outline'
                    }
                    onClick={() => handleStatusChange(tab.value)}
                  >
                    {tab.label}
                  </Button>
                ))}
              </div>
            </div>

            <div className="space-y-2">
              <h3 className="text-base font-medium text-black">ประเภทผู้ใช้</h3>
              <div className="flex gap-2 flex-wrap">
                {ROLE_TABS.map((tab) => (
                  <Button
                    key={tab.value}
                    variant={filters.role === tab.value ? 'default' : 'outline'}
                    onClick={() => handleRoleChange(tab.value)}
                  >
                    {tab.label}
                  </Button>
                ))}
              </div>
            </div>
          </div> */}
        </div>
      </CardContent>
    </Card>
  )
}
